import Router from 'vue-router'
import MemberRouter from './Member.js'
import Notfound from '@/base/Notfound'
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/main',
    },
    {
      path: '*',
      name: 'Notfound',
      component: Notfound,
    },
    {
      path: '/main',
      component: () => import('@/page/Home'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('@/components/Home'),
          meta: {
            title: '首页',
          },
        },
        {
          path: '/settle',
          name: 'settleHome',
          component: () => import('@/components/SettleHome'),
          meta: {
            title: '入驻首页',
          },

        },
        {
          path: '/partners',
          name: 'partners',
          component: () => import('@/components/Home/partnersList'),
          meta: {
            title: '合作机构更多',
          },

        },
        {
          path: '/partners1',
          name: 'partners1',
          component: () => import('@/components/Home/partnersList1'),
          meta: {
            title: '小工具更多',
          },

        },
        {
          path: 'consultationOrderDetail',
          name: 'consultationOrderDetail',
          component: () => import("@/components/Member/ConsultationOrder/detail.vue"),
          meta: {
            title: '专家咨询 订单详情',
            navBol: true
          }
        },
        {
          path: '/bankPay',
          name: 'bankPay',
          component: () => import("@/components/bankPay/index.vue"),
          meta: {
            title: '银联支付',
            navBol: true
          }
        },
        {
          path: '/expert',
          name: 'expertCenter',
          component: () => import('@/components/expertCenter/home'),
          meta: {
            title: '专家中心首页',
          },
        },
        {
          path: '/expert/step',
          name: 'expertStep',
          component: () => import('@/components/expertCenter/expertStep'),
          meta: {
            title: '专家中心入驻流程',
          },
        },
        {
          path: '/first',
          name: 'main',
          component: () => import('@/components/Main'),
          meta: {
            title: '贸易通首页',
          },
        },
        {
          path: '/train/list',
          name: 'train',
          component: () => import('@/components/train/list/index.vue'),
          meta: {
            title: '培训服务列表'
          }

        },
        {
          path: '/train/home',
          name: 'train',
          component: () => import('@/components/train/home/index.vue'),
          meta: {
            title: '培训服务详情'
          }

        },
        {
          path: '/train/vipDetail',
          name: 'vipDetail',
          component: () => import('@/components/train/vipDetail/index.vue'),
          meta: {
            title: '开通会员'
          }
        },
        {
          path: '/train/vip',
          name: 'vip',
          component: () => import('@/components/train/vip/index.vue'),
          meta: {
            title: '培训服务-开通会员'
          }

        },
        {
          path: '/train/view',
          name: 'view',
          component: () => import('@/components/train/view/index.vue'),
          meta: {
            title: '培训服务-观看界面'
          }

        },
        {
          path: '/train/buying',
          name: 'buying',
          component: () => import('@/components/train/buying/index.vue'),
          meta: {
            title: '培训服务-购买课程'
          }

        },
        {
          path: '/settle/step',
          name: 'settleStep',
          component: () => import('@/components/SettleStep'),
          meta: {
            title: '入驻流程',
          },
        },
        {
          path: '/expert/list',
          name: 'expertList',
          component: () => import('@/components/expertService/expertList/index.vue'),
          meta: {
            title: '专家列表',
          },
        },
        {
          path: '/expert/detail',
          name: 'expertDetail',
          component: () => import('@/components/expertService/expertDetail/index.vue'),
          meta: {
            title: '专家详情',
          },
        },
        {
          path: '/expert/buyOrder',
          name: 'buyOrder',
          component: () => import('@/components/expertService/buyOrder/index.vue'),
          meta: {
            title: '立即咨询下单',
          },
        },
        {
          path: '/expert/payOrder',
          name: 'payOrder',
          component: () => import('@/components/expertService/payOrder/index.vue'),
          meta: {
            title: '立即咨询支付',
          },
        },
        {
          path: '/expert/consultationType',
          name: 'consultation-type',
          component: () => import('@/components/expertService/consultationType/index.vue'),
          meta: {
            title: '咨询页面 选择咨询类型',
          },
        },
        {
          path: '/expert/consultation/chat',
          name: 'consultationChat',
          component: () => import('@/components/expertService/consultationChat/index.vue'),
          meta: {
            title: '咨询界面',
          },
        },
        {
          path: '/expert/consultation/evaluate',
          name: 'consultationEvaluate',
          component: () => import('@/components/expertService/consultationEvaluate/index.vue'),
          meta: {
            title: '咨询评价',
          },
        },
        {
          path: '/selfHelp/offerHome',
          name: 'offerHome',
          component: () => import('@/components/selfHelpOffer/offerHome/index.vue'),
          meta: {
            title: '自助报价 首页',
          },
        },
        {
          path: '/selfHelp/placeOrder',
          name: 'placeOrderPro',
          component: () => import('@/components/selfHelpOffer/placeOrder/index.vue'),
          meta: {
            title: '自助报价 下单流程',
          },
        },
        {
          path: '/selfHelp/fillApplication',
          name: 'fillApplication',
          component: () => import('@/components/selfHelpOffer/FillApplication/index.vue'),
          meta: {
            title: '自助报价 下单流程 填写申请表',
          },
        },
        {
          path: '/selfHelp/payment',
          name: 'Payment',
          component: () => import('@/components/selfHelpOffer/payment/index.vue'),
          meta: {
            title: '自助报价 下单流程 支付',
          },
        },
        {
          path: '/selfHelp/inService',
          name: 'InService',
          component: () => import('@/components/selfHelpOffer/InService/index.vue'),
          meta: {
            title: '自助报价 下单流程 服务中',
          },
        },
        {
          path: '/selfHelp/ServiceEvaluation',
          name: 'ServiceEvaluation',
          component: () => import('@/components/selfHelpOffer/ServiceEvaluation/index.vue'),
          meta: {
            title: '自助报价 下单流程 服务评价',
          },
        },
        {
          path: '/member',
          redirect: '/member/home',
          name: 'MemberCenter',
          component: () => import('@/page/Member'),
          meta: {
            title: '会员客户中心',
            navBol: true,
          },
          children: MemberRouter,
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/page/Register/phone'),
          meta: {
            title: '注册首页'
          }
        },
        {
          path: '/register-mail',
          name: 'register-mail',
          component: () => import('@/page/Register/mail'),
          meta: {
            title: '邮箱注册'
          }
        },
        {
          path: '/register-code',
          name: 'register-code',
          component: () => import('@/page/Register/code'),
          meta: {
            title: '微信注册'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/page/Login/'),
          meta: {
            title: '登录首页'
          }
        },
        {
          path: '/retrievePassword',
          name: 'retrievePassword',
          component: () => import('@/page/FindPassword/retrievePassword.vue'),
          meta: {
            title: '找回密码 邮箱1'
          },
          redirect: '/retrievePassword/step1',
          children: [
            {
              path: '/retrievePassword/step1',
              name: 'emailStep1',
              component: () => import('@/page/FindPassword/Steps/step1.vue'),
              meta: {
                title: '邮箱/手机找回密码步骤1'
              }
            },
            {
              path: '/retrievePassword/step2',
              name: 'emailStep2',
              component: () => import('@/page/FindPassword/Steps/step2.vue'),
              meta: {
                title: '邮箱找回密码步骤2'
              }
            },
            {
              path: '/retrievePassword/step3',
              name: 'emailStep3',
              component: () => import('@/page/FindPassword/Steps/step3.vue'),
              meta: {
                title: '邮箱/手机找回密码步骤3'
              }
            },
            {
              path: '/retrievePassword/step4',
              name: 'emailStep4',
              component: () => import('@/page/FindPassword/Steps/step4.vue'),
              meta: {
                title: '邮箱/手机找回密码步骤4'
              }
            },
            {
              path: '/retrievePassword/step5',
              name: 'emailStep5',
              component: () => import('@/page/FindPassword/Steps/step5.vue'),
              meta: {
                title: '邮箱/手机找回密码步骤5'
              }
            }
          ]
        },

        {
          path: '/consult',
          name: 'consult',
          component: () => import('@/components/Certificate/consult.vue'),
          meta: {
            title: '咨询留言'
          }
        },
        {
          path: '/byConsult',
          name: 'byConsult',
          component: () => import('@/components/Certificate/serviceConsult/byConsult.vue'),
          meta: {
            title: '服务咨询 发起咨询'
          }
        },
        {
          path: '/consultOrder',
          name: 'consultOrder',
          component: () => import('@/components/Certificate/serviceConsult/order.vue'),
          meta: {
            title: '服务咨询 下单流程1'
          }
        },
        {
          path: '/consultOrderSuccess',
          name: 'consultOrderSuccess',
          component: () => import('@/components/Certificate/serviceConsult/orderSuccess.vue'),
          meta: {
            title: '服务咨询 下单流程1_1 版本1'
          }
        },
        {
          path: '/consultPay',
          name: 'consultPay',
          component: () => import('@/components/Certificate/serviceConsult/pay.vue'),
          meta: {
            title: '服务咨询 下单流程2_1 版本1'
          }
        },
        {
          path: '/consultPaySuccess',
          name: 'consultPaySuccess',
          component: () => import('@/components/Certificate/serviceConsult/paySuccess.vue'),
          meta: {
            title: '服务咨询 下单流程2_2'
          }
        },
        {
          path: '/consultPayError',
          name: 'consultPayError',
          component: () => import('@/components/Certificate/serviceConsult/payError.vue'),
          meta: {
            title: '服务咨询 下单流程2_3'
          }
        },
        {
          path: '/consultServicing',
          name: 'consultServicing',
          component: () => import('@/components/Certificate/serviceConsult/consultServicing.vue'),
          meta: {
            title: '服务咨询 下单流程3 版本1'
          }
        },
        {
          path: '/consultServiced',
          name: 'consultServiced',
          component: () => import('@/components/Certificate/serviceConsult/consultServiced.vue'),
          meta: {
            title: '服务咨询 下单流程4'
          }
        },
        {
          path: '/serviceList',
          name: 'serviceList',
          component: () => import('@/components/Certificate/serviceList.vue'),
          meta: {
            title: '检测认证服务列表'
          }
        },
        {
          path: '/serviceDetail',
          name: 'serviceDetail',
          component: () => import('@/components/Certificate/serviceDetail.vue'),
          meta: {
            title: '检测认证服务详情'
          }
        },
        {
          path: '/oneTypeDetail',
          name: 'oneTypeDetail',
          component: () => import('@/components/Certificate/oneTypeDetail.vue'),
          meta: {
            title: '分类详情'
          }
        },
        {
          path: '/programList',
          name: 'programList',
          component: () => import('@/components/Certificate/programList.vue'),
          meta: {
            title: '标准项目列表'
          }
        },
        {
          path: '/database/home',
          name: 'database-home',
          component: () => import('@/components/database/home/index.vue'),
          meta: {
            title: '资料库首页'
          }
        },
        {
          path: '/database/more',
          name: 'database-more',
          component: () => import('@/components/database/more/index.vue'),
          meta: {
            title: '资料库-更多资料'
          }
        },
        {
          path: '/database/find',
          name: 'databaseFind',
          component: () => import('@/components/database/find/index.vue'),
          meta: {
            title: '资料库-搜索'
          }
        },
        {
          path: '/database/detail',
          name: 'databaseDetail',
          component: () => import('@/components/database/detail/index.vue'),
          meta: {
            title: '资料库-资料详情'
          }
        },
        {
          path: '/infoquery',
          name: 'infoquery',
          component: () => import('@/components/InfoQuery'),
          meta: {
            title: '信息查询'
          },
          children: [
            {
              path: '/infoquery/result',
              name: 'result',
              component: () => import('@/components/InfoQuery/form/fomrResult.vue'),
            },
            {
              path: '/infoquery/institution',
              name: 'institution',
              component: () => import('@/components/InfoQuery/form/formInstitution.vue'),
            },
            {
              path: '/infoquery/qualification',
              name: 'qualification',
              component: () => import('@/components/InfoQuery/form/formQualification.vue'),
            },
            {
              path: '/infoquery/rules',
              name: 'rules',
              component: () => import('@/components/InfoQuery/form/formRules.vue'),
            },
            {
              path: '/infoquery/source',
              name: 'source',
              component: () => import('@/components/InfoQuery/form/formSource.vue'),
            },
            {
              path: '/infoquery/standard',
              name: 'standard',
              component: () => import('@/components/InfoQuery/form/formStandard.vue'),
            },
          ], redirect: '/infoquery/result'
        },
        {
          path: '/joinList',
          name: 'joinList',
          component: () => import('@/components/Certificate/joinList.vue'),
          meta: {
            title: '检测认证标准服务 加入清单'
          }
        },
        {
          path: '/cartList',
          name: 'cartList',
          component: () => import('@/components/Certificate/cartList.vue'),
          meta: {
            title: '检测认证标准服务 购物车清单'
          }
        },
        {
          path: '/order',
          name: 'order',
          component: () => import('@/components/Certificate/order.vue'),
          meta: {
            title: '检测认证标准服务 下单流程1'
          }
        },
        {
          path: '/orderSuccess',
          name: 'orderSuccess',
          component: () => import('@/components/Certificate/orderSuccess.vue'),
          meta: {
            title: '检测认证标准服务 下单流程2'
          }
        },
        {
          path: '/pay_1',
          name: 'pay_1',
          component: () => import('@/components/Certificate/pay/pay_1.vue'),
          meta: {
            title: '检测认证标准服务 支付流程-4 支付_1'
          }
        },
        {
          path: '/paySuccess',
          name: 'paySuccess',
          component: () => import('@/components/Certificate/pay/paySuccess.vue'),
          meta: {
            title: '检测认证标准服务-下单流程4-支付_2'
          }
        },
        {
          path: '/payError',
          name: 'payError',
          component: () => import('@/components/Certificate/pay/payError.vue'),
          meta: {
            title: '检测认证标准服务 支付流程-4 支付_3'
          }
        },
        {
          path: '/servicing',
          name: 'servicing',
          component: () => import('@/components/Certificate/service/servicing.vue'),
          meta: {
            title: '检测认证标准服务 支付流程-4 服务中'
          }
        },
        {
          path: '/serviced',
          name: 'serviced',
          component: () => import('@/components/Certificate/service/serviced.vue'),
          meta: {
            title: '检测认证标准服务 支付流程-4 服务完成'
          }
        },
        // 下面是13部分的路由
        {
          path: '/orderDetail',
          name: 'orderDetail',
          component: () => import("@/components/Member/Order/orderDetail/index.vue"),
          meta: {
            title: '检测认证 订单详情 _基本信息 _申请单'
          },
          redirect: '/orderDetail/baseInfo',
          children: [
            {
              path: '/orderDetail/baseInfo',
              name: 'baseInfo',
              component: () => import("@/components/Member/Order/orderDetail/baseInfo.vue"),
              meta: {
                title: '检测认证 订单详情 _基本信息'
              },
            },
            {
              path: '/orderDetail/applyTable',
              name: 'applyTable',
              component: () => import("@/components/Member/Order/orderDetail/applyTable.vue"),
              meta: {
                title: '检测认证 订单详情 _申请单'
              },
            }
          ]
        },
		{
		  path: '/certificateDetail',
		  name: 'certificateDetail',
		  component: () => import("@/components/Member/certificate/certificateDetail/index.vue"),
		  meta: {
		    title: '检测机构 证书详情'
		  },
		  redirect: '/certificateDetail/baseInfo',
		  children: [
		    {
		      path: '/certificateDetail/baseInfo',
		      name: 'baseInfo',
		      component: () => import("@/components/Member/certificate/certificateDetail/baseInfo.vue"),
		      meta: {
		        title: '检测机构 证书管理 证书详情'
		      },
		    }
		  ]
		},
        {
          path: '/consultStartEvaluate',
          name: 'startEvaluate',
          component: () => import('@/components/Member/Evaluation/startEvaluate.vue'),
          meta: {
            title: '专家咨询 订单评价'
          }
        },
        {
          path: '/additionalEvaluate',
          name: 'additionalEvaluate',
          component: () => import('@/components/Member/Evaluation/additionalEvaluate.vue'),
          meta: {
            title: '专家咨询 追加评价'
          }
        },
        {
          path: '/consultFinishEvaluate',
          name: 'finishEvaluate',
          component: () => import('@/components/Member/Evaluation/finishEvaluate.vue'),
          meta: {
            title: '专家咨询 订单评价_2'
          }
        },
        {
          path: '/testStartEvaluate',
          name: 'testStartEvaluate',
          component: () => import('@/components/Member/TestEvaluation/startEvaluate.vue'),
          meta: {
            title: '检测认证 评价 订单评价'
          }
        },
        {
          path: '/addTestStartEvaluate',
          name: 'addTestStartEvaluate',
          component: () => import('@/components/Member/TestEvaluation/addEvaluate.vue'),
          meta: {
            title: '检测认证 评价 订单追加评价'
          }
        },
        {
          path: '/testFinishEvaluate',
          name: 'testFinishEvaluate',
          component: () => import('@/components/Member/TestEvaluation/finishEvaluate.vue'),
          meta: {
            title: '检测认证 评价 订单评价_2'
          }
        },
        {
          path: '/trainOrderDetail',
          name: 'trainOrderDetail',
          component: () => import('@/components/Member/TrainOrderDetail'),
          meta: {
            title: '培训-培训订单_详情 版本2'
          }
        },
        {
          path: '/trainStartEvaluation',
          name: 'trainStartEvaluate',
          component: () => import('@/components/Member/TrainClassEvaluation/startEvaluate.vue'),
          meta: {
            title: '培训-课程评价 订单评价'
          }
        },
        {
          path: '/reevaluation',
          name: 'reevaluation',
          component: () => import('@/components/Member/TrainClassEvaluation/reevaluation.vue'),
          meta: {
            title: '培训-课程评价 追评'
          }
        },
        {
          path: '/trainFinishEvaluation',
          name: 'trainFinishEvaluate',
          component: () => import('@/components/Member/TrainClassEvaluation/finishEvaluate.vue'),
          meta: {
            title: '培训-课程评价 订单评价_2'
          }
        },
        {
          path: '/customerDocking',
          name: 'customerDocking',
          component: () => import('@/components/Member/ButtService/index.vue'),
          meta: {
            title: '账户服务-客服对接 版本1'
          }
        },

        //十二部分的路由
        {
          path: '/channel',
          name: 'channel',
          component: () => import('@/components/AgentChannel/index.vue'),
          meta: {
            title: '代理渠道-首页 版本2'
          }
        },
        {
          path: '/channelProcess',
          name: 'channelProcess',
          component: () => import('@/components/ChannelProcess/index.vue'),
          meta: {
            title: '代理渠道入驻流程1'
          },
          redirect: '/channelProcess/enterpriseProcess',
          children: [
            {
              path: '/channelProcess/personProcess',
              name: 'personProcess',
              component: () => import('@/components/ChannelProcess/person.vue'),
              meta: {
                title: '代理渠道入驻流程1 个人',
              },
            },
            {
              path: '/channelProcess/expertProcess',
              name: 'expertProcess',
              component: () => import('@/components/ChannelProcess/expert.vue'),
              meta: {
                title: '代理渠道入驻流程1 专家',
              },
            },
            {
              path: '/channelProcess/enterpriseProcess',
              name: 'enterpriseProcess',
              component: () => import('@/components/ChannelProcess/enterprise.vue'),
              meta: {
                title: '代理渠道入驻流程1 企业公司',
              },
            },
          ]
        },
        {
          path: '/channelWait',
          name: 'channelWait',
          component: () => import('@/components/ChannelProcess/submit/wait'),
          meta: {
            title: '代理渠道入驻流程-2_1 版本1'
          }
        },
        {
          path: '/channelFail',
          name: 'channelFail',
          component: () => import('@/components/ChannelProcess/submit/fail'),
          meta: {
            title: '代理渠道入驻流程-2_2 版本1'
          }
        },
        {
          path: '/channelSuccess',
          name: 'channelSuccess',
          component: () => import('@/components/ChannelProcess/submit/success'),
          meta: {
            title: '代理渠道入驻流程-3 版本2'
          }
        },
        //会员 询价单详情
        {
          path: '/inquirySheetDetails',
          name: 'memberInquirySheetDetails',
          component: () => import("@/components/InquirySheetDetails"),
          meta: {
            title: '检测认证 询价单详情',

          }
        },

      ]
    },
    {
      path: '/iframePxfu',
      name: 'iframePxfu',
      component: () => import('@/components/Home/iframePxfu'),
      meta: {
        title: '培训服务'
      }
    },
    {
      path: '/iframeExpertsHome',
      name: 'iframeExpertsHome',
      component: () => import('@/components/Home/iframeExpertsHome'),
      meta: {
        title: '专家'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js